module.exports = __webpack_public_path__ + "static/media/attraction3.27cf1b1f.jpg";